module.exports = __webpack_public_path__ + "static/calorex_home_slide_familia_calorex_mb-0605c56ffddecd4dcb716b31d04f71ba.png";